import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, OnInit } from '@angular/core';
import { CatalogService } from '../../service/catalog.service';
import { EventService } from '../../service/event.service';
import { tap, finalize } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { CatalogComponent } from '../catalog/catalog.component';
import { DataService } from 'src/app/service/data.service';
import { Modal } from '../controls/modal/modal.service';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { Events } from 'src/app/service/websocket.service';

@Component({
    selector: 'app-catalog-overview',
    templateUrl: './catalog-overview.component.html',
    styleUrls: ['./catalog-overview.component.css'],
    standalone: false
})
export class CatalogOverviewComponent extends CatalogComponent implements OnInit {

  cols: DataTableColumn[];
  rows: DataTableRow[] = [];

  solutionInfoSubscription: Subscription;

  constructor(public catalogSrv: CatalogService, public eventService: EventService, public router: Router,
    public dataSrv: DataService, public route: ActivatedRoute, public modal: Modal, public el: ElementRef) {
    super(catalogSrv, eventService, router, dataSrv, route, modal, el);
    this.cols = Array<DataTableColumn>(
      new DataTableColumn('displayName', 'Name', ColumnType.STRING, false, "60"),
      new DataTableColumn('version', 'Version', ColumnType.STRING, false, "20"),
      new DataTableColumn('releaseTimestamp', 'Release date', ColumnType.DATEFROMNOW, true, "20", ColumnSort.DESC)
    );
  }

  ngOnInit(): void {
    this.solutionInfoSubscription = this.eventService.currentSolutionInfo$.subscribe(newSolutionInfo => {
      this.isManifestUpdating = newSolutionInfo.manifestStatus.isUpdating;
      this.isSapMode = newSolutionInfo.isSModeEnabled;
      if(!this.isManifestUpdating){
        this.getLatestProducts();
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if (msg.eventType == Events.ManifestUpdateStarted) {
        this.isManifestUpdating = true;
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.reloadAfterManifestUpdate();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.solutionInfoSubscription != undefined) {
      this.solutionInfoSubscription.unsubscribe();
    }
    if (this.eventMessageSubscription != undefined) {
      this.eventMessageSubscription.unsubscribe();
    }
  }

  getLatestProducts(): void {
    this.isLoading = true;
    var tmpRows: DataTableRow[] = [];
    this.rows = [];
    this.catalogSrv.getLatestReleases().pipe(
      tap(resp => {
        resp.body.forEach(latest => {
          latest.displayName = this.isSapMode ? latest.sapName : latest.productName;
          tmpRows.push(new DataTableRow(latest, [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, latest, false)]))
        });
        this.rows = tmpRows;
      }),
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe();
  }

  showDetails(productRow: DataTableRow): void {
    this.navigateToCatalogDetails(productRow.data.productName, productRow.data.product_uid);
  }

  clickLatest(row: DataTableRow): void{
    this.showDetails(row);
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Details"){
      this.navigateToCatalogDetails(event.data[0].productName, event.data[0].product_uid);
    }
  }

  navigateToCatalogDetails(name:string, uid:string): void {
    this.router.navigate(['/catalog/details/' + name + '/' + uid]);
  }
}
